export const AI_CHAT_WORKFLOW_LAUNCH_QUERY_KEY = 'ai_chat_launch';
export const AI_CHAT_WORKFLOW_LAUNCH_PAYLOAD_KEY_QUERY = 'ai_chat_payload_key';
const AI_CHAT_WORKFLOW_LAUNCH_STORAGE_PREFIX = 'ai-chat-launch:';

const safeJsonParse = (raw) => {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const persistAiChatWorkflowLaunchPayload = (payload) => {
  if (!payload || typeof window === 'undefined' || !window.sessionStorage) return '';
  const keySuffix = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const storageKey = `${AI_CHAT_WORKFLOW_LAUNCH_STORAGE_PREFIX}${keySuffix}`;
  window.sessionStorage.setItem(storageKey, JSON.stringify(payload));
  return storageKey;
};

export const buildAiChatWorkflowLaunchQuery = (existingQuery, launchType, payloadKey) => ({
  ...(existingQuery || {}),
  [AI_CHAT_WORKFLOW_LAUNCH_QUERY_KEY]: launchType,
  [AI_CHAT_WORKFLOW_LAUNCH_PAYLOAD_KEY_QUERY]: payloadKey,
});

export const clearAiChatWorkflowLaunchQuery = async (router, route) => {
  if (!router || !route) return;
  const query = { ...(route.query || {}) };
  if (!query[AI_CHAT_WORKFLOW_LAUNCH_QUERY_KEY] && !query[AI_CHAT_WORKFLOW_LAUNCH_PAYLOAD_KEY_QUERY]) {
    return;
  }
  delete query[AI_CHAT_WORKFLOW_LAUNCH_QUERY_KEY];
  delete query[AI_CHAT_WORKFLOW_LAUNCH_PAYLOAD_KEY_QUERY];
  try {
    await router.replace({ query });
  } catch {
    // ignore navigation duplication noise
  }
};

export const consumeAiChatWorkflowLaunchFromRoute = async (router, route) => {
  const launchType = String(route?.query?.[AI_CHAT_WORKFLOW_LAUNCH_QUERY_KEY] || '').trim();
  const payloadKey = String(route?.query?.[AI_CHAT_WORKFLOW_LAUNCH_PAYLOAD_KEY_QUERY] || '').trim();
  if (!launchType || !payloadKey || typeof window === 'undefined' || !window.sessionStorage) {
    return null;
  }

  const rawPayload = window.sessionStorage.getItem(payloadKey);
  window.sessionStorage.removeItem(payloadKey);
  await clearAiChatWorkflowLaunchQuery(router, route);

  if (!rawPayload) return null;
  const payload = safeJsonParse(rawPayload);
  if (!payload || typeof payload !== 'object') return null;
  return { launchType, payload };
};
